import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/produit/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="img-hover aspect-[3/4] bg-[#151516] mb-5 overflow-hidden">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="overline text-[10px] mb-2">{categoryLabel(product.category)}</div>
      <h3 className="font-serif text-xl md:text-2xl text-[#F5F5F0] leading-tight mb-2 group-hover:text-[#D4AF37] transition-colors">
        {product.name}
      </h3>
      <div className="text-sm text-[#A3A39D] tracking-wider">{formatPrice(product.price)}</div>
    </Link>
  );
}

const FALLBACK = {
  meubles: "Meubles",
  decoration: "Décoration",
  bijoux: "Bijoux africains",
  artisanat: "Artisanat africain",
  autres: "Pièces rares",
};

export function categoryLabel(c, t) {
  if (t) {
    const k = `catalog.filters.${c}`;
    const v = t(k);
    if (v && v !== k) return v;
  }
  return FALLBACK[c] || c;
}

export function formatPrice(price) {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(price);
}
